module.exports = __webpack_public_path__ + "img/no_inspection_report.ccd5eb00.png";